// extracted by mini-css-extract-plugin
export default {"ballsContainer":"styles_ballsContainer__nAXOH"};